import { API_URL } from '../../../app-config/constants';
import type { Coach } from '../../react/features/AiCoach/types';
import { get, post, put, remove } from '../request';

const BASE_URL = `${API_URL}/copilot/admin`;

getCoaches.operation = 'READ';
getCoaches.updateOnCreate = (args: [], x: Coach, xs: Coach[]) => [x, ...xs];
export function getCoaches() {
    return get<Coach[]>(`${BASE_URL}/assistants`);
}

getCoach.operation = 'READ';
getCoach.byId = true;
export function getCoach(id: string) {
    return get<Coach>(`${BASE_URL}/assistants/${id}`);
}

createCoach.operation = 'CREATE';
export function createCoach(assistant: Omit<Coach, 'id'>) {
    return post<Coach>(`${BASE_URL}/assistants`, { postData: assistant });
}

updateCoach.operation = 'UPDATE';
export function updateCoach(assistant: Coach) {
    return put<Coach>(`${BASE_URL}/assistants/${assistant.id}`, { postData: assistant });
}

deleteCoach.operation = 'DELETE';
export function deleteCoach(id: string) {
    return remove(`${BASE_URL}/assistants/${id}`);
}
